import { render, staticRenderFns } from "./BookingCancelationForm.vue?vue&type=template&id=5b8c667b&scoped=true&"
import script from "./BookingCancelationForm.vue?vue&type=script&lang=ts&"
export * from "./BookingCancelationForm.vue?vue&type=script&lang=ts&"
import style0 from "./BookingCancelationForm.vue?vue&type=style&index=0&id=5b8c667b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8c667b",
  null
  
)

export default component.exports